export default function getArray(obj: unknown) {
  return Array.isArray(obj) ? obj : [];
}
